<template>
<div class="content" v-cloak style="background: #f0f0f0">
    <div class="page page_rank" >
        <div class="top_bar">
            <a href="javascript:history.go(-1);" class="back">返回</a>
        </div>
        <div class="rank_content">
            <div class="tip_name">近10天成绩排行榜</div>
            <div class="rank_list">
                <div class="rank_top">
                    <div class="top_2" v-if="rank_list.length >= 2">
                        <span>
                            <img :src="rank_list[1].avatar" alt="">
                            <s class="s2">2</s>
                        </span>
                        <span>{{rank_list[1].nickName}}</span>
                        <em>{{rank_list[1].max}}分</em>
                    </div>
                    <div class="top_1" v-if="rank_list.length >= 1">
                        <div style="">
                            <span>
                                <img :src="rank_list[0].avatar" alt="">
                                <s class="s1">1</s>
                            </span>
                            <span>{{rank_list[0].nickName}}</span>
                        </div>
                        <em>{{rank_list[0].max}}分</em>
                    </div>
                    <div class="top_2" v-if="rank_list.length >= 3">
                        <span>
                            <img :src="rank_list[2].avatar" alt="">
                            <s class="s3">3</s>
                        </span>
                        <span>{{rank_list[2].nickName}}</span>
                        <em>{{rank_list[2].max}}分</em>
                    </div>
                </div>
                <ul>
                    <li v-for="(item,index) in rank_list" :key="index" v-show="index>3">
                        <div class="rank_order">{{index}}</div>
                        <div class="rank_pic">
                            <img :src="item.avatar" alt="" >
                        </div>
                        <div class="rank_info">
                            <span>{{item.nickName}}</span>
                            <span>{{item.max}}分</span>
                            <p>累计模拟次数：{{item.mockNum}}次 <em>平均分：{{item.avg | fixed}}分</em></p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="user_rank">
            <div class="rank_list">
                <li>
                    <div class="rank_order">{{user_index}}</div>
                    <div class="rank_pic">
                        <img :src="user_rank.avatar" alt="" >
                    </div>
                    <div class="rank_info">
                        <span>{{user_rank.nickName}}</span>
                        <span>{{user_rank.max}}分</span>
                        <p>累计模拟次数：{{user_rank.mockNum}}次 <em>平均分：{{user_rank.avg | fixed}}分</em></p>
                    </div>
                </li>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import { mockRank } from '../../api';
export default {
    el:".content",
    data(){
        return {
            worktype:"",/*公种id*/
            rank_list:[],
            user_rank:{
                max: 0,
                mockNum: 0,
                avg: 0,
                nickName: ''

            },
            user_id:'',
            user_index: 0,
        }
    } ,
    created() {
        this.worktype =  this.common.getQueryString("worktype");
        // this.user_id = this.common.GetQueryString("userId");
        this.getRankList();
    },
    filters:{
      fixed:function (item) {
          if(item != null && item != "" && item != undefined) {
              return item.toFixed();
          }else{
              return item;
          }

      }
    },
    methods:{
        /*获得排行榜*/
        getRankList:function () {
            var vm =this;
            mockRank( vm.worktype).then(res=>{
                console.log(res)
            })
            // vm.$http.post(vm.url8,{workType : vm.worktype},{emulateJSON: true}).then(function (response) {
            //     var result = response.data;
            //     console.log(result);
            //     if (result.code == 0) {
            //         vm.rank_list = result.data;
            //         vm.rank_list.forEach(function (item,index) {
            //             if(item.userId == vm.user_id){
            //                 vm.user_rank = item;
            //                 vm.user_index = index+1;
            //             }
            //         })

            //     }
            // })
        }
    },
}
</script>

<style>
.user_rank{position: fixed;bottom: 0px;left: 0px;border: none;width: 100%;padding: 0px 15px;background: #fff;display: flex;box-sizing: border-box}
.user_rank .rank_list{border-radius: 0;padding: 0px 10px;margin:0px;}
.page_rank{background:url("../../asset/images3/rank_bg.png") top center no-repeat;;padding: 0px 15px 72px;box-sizing: border-box;
background-size: 100% 208px}
.top_bar{display: block;text-align: left}
.top_bar a{display: inline-block;font-size: 18px;color: #fff;margin-top: 10px;}
.rank_content{margin-top: 112px;display: flex;flex-wrap: wrap}

.rank_content .tip_name{text-align: center;color: #fff;width: 100%;font-size: 20px;font-weight: bold}
.rank_list{background: #ffffff;width: 100%;padding: 10px;margin-top: 32px; border-radius: 10px;}
.rank_list ul{margin-top: 10px;}
.rank_list li{display: flex;width: 100%;align-items: center;border-bottom: 1px solid #f0f0f0;padding: 10px 0px;}
.rank_list li:first-child{border-top: 1px solid #f0f0f0 }
.rank_list li .rank_info{flex: 1;display: inline-flex;flex-wrap: wrap;justify-content: space-between;align-items: center}
.rank_list li .rank_order{font-size:20px;color: #949494}
.rank_list li div{display: flex;align-items: center}
.rank_list img{width: 62px;height: 62px;border-radius: 50%}
.rank_list li img{width: 50px;height: 50px;border-radius: 50%;}
.rank_info p em{font-style: normal;float: right}
.rank_info p{width: 100%;font-size: 12px;color: #999999}
.rank_info span{width: 50%;text-align: left}
.rank_info span:nth-child(1){text-align: left}
.rank_info span:nth-child(2){text-align: right}
.rank_top{display: flex;justify-content: space-between}
.rank_top .top_2{width: 29%;}
.rank_top .top_1{    position: absolute;  box-sizing: border-box;  width: 32%;  left: 35%;  margin-top: -37px;}
.top_1 div{width: 100%;border-top-right-radius: 10px;border-top-left-radius: 10px;padding-top: 34px;background: #ffffff;border-top:1px solid #cccccc;border-left:1px solid #cccccc;border-right:1px solid #cccccc}
.rank_top div{/*display: flex;justify-content: center;flex-wrap: wrap;align-items: center*/}
.rank_top div span{width: 100%;text-align: center;/*line-height: 1;*/text-align: center;display: block;font-size: 14px;color: #333333}
.rank_top div span img{display: inline-block;}
.rank_top div em{width: 100%;text-align: center;font-style: normal;color: #996633;font-size: 18px;font-weight: bold;/*line-height: 1;*/display: block}
.rank_order{width: 7%;text-align: left}
.rank_pic{width: 20%;text-align: center;}
.rank_top s{width: 20px;height: 20px;border-radius: 50%;text-align: center;display: inline-flex;align-items: center;position: absolute;justify-content: center;
    text-decoration: none;line-height: 20px;color: #fff;font-size: 14px;border: 1px solid #fff;}
.rank_top .s1{background: red;margin-top: 33px;right: 12%;}
.rank_top .s2{background: #ff8100;margin-top: 33px;left:25%;}
.rank_top .s3{background: #ff8100;margin-top: 33px;right: 8%;}

</style>